var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories-loader mt-8 mb-0"},_vm._l((new Array(_vm.$vuetify.breakpoint.xsOnly ? 8 : 18)),function(chip,i){return _c('v-skeleton-loader',{key:i,staticClass:"ma-1",attrs:{"type":"chip"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }